import Modal from "@/components/modal";
import PaymentMethodsForms from "./payment-methods-forms";
import type { SubmitPaymentChoice } from "./mobile-money-payment-form";
import { PaymentCategory } from "@/features/applications/repositories/licences-repository.ts";
import type { ZanCustomerFields } from "@/features/applications/services/applications-services";

interface IProps extends ZanCustomerFields {
    isOpen: boolean;
    onClose: () => void;
    onSubmit?: (choice: SubmitPaymentChoice) => void;
    inspectionFee?: string;
    totalFees?: string;
    defaultPhoneNumber?: string;
}

export default function InvestmentPaymentModal({
    isOpen,
    onClose,
    onSubmit,
    inspectionFee,
    totalFees,
    defaultPhoneNumber,
    ...customerFields
}: IProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <PaymentMethodsForms
                header="Inspection Payment Fee"
                onSubmit={onSubmit}
                inspectionFee={inspectionFee}
                totalFees={totalFees ?? inspectionFee}
                paymentCategory={PaymentCategory.INSPECTIONFEE}
                defaultPhoneNumber={defaultPhoneNumber}
                {...customerFields}
            />
        </Modal>
    );
}
